export const getCurrentDate = () => {
  return Date.now();
};